
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function Filter(props) {
  return (
    <SvgIcon {...props}>
      <path d="M6.917 10.083a.792.792 0 0 1-1.584 0V6.917a.792.792 0
        0 1 1.584 0v.791h8.708a.792.792 0 0 1 0 1.584H6.917zm0
        3.959a.792.792 0 0 1-.792.791h-4.75a.792.792 0 0 1 0-1.583h4.75c.437
        0 .792.354.792.792zm3.166 1.583a.792.792 0 0 1-1.583 0v-3.167a.792.792
        0 0 1 1.583 0v.792h5.542a.792.792 0 0 1 0 1.583h-5.542zM3.75 8.5a.792.792
        0 0 1-.792.792H1.375a.792.792 0 0 1 0-1.584h1.583c.438 0
        .792.355.792.792zm6.333-5.542a.792.792 0 0 1-.791.792H1.375a.792.792
        0 0 1 0-1.583h7.917c.437 0 .791.354.791.791zm3.167 1.584a.792.792 0
        0 1-1.583 0V1.375a.792.792 0 0 1 1.583 0v.792h2.375a.792.792 0 0 1 0 1.583H13.25z"
      />
    </SvgIcon>
  );
}
